const tokenProperty = 'tokens';
const tokenVocabulary = 'audit_token';

module.exports = {
  tokenProperty,
  tokenVocabulary,
};
